import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
var renderLinkText = function renderLinkText(link) {
  var pieces = link.split('://');
  return pieces[pieces.length - 1];
};
var SingleLink = function SingleLink(_ref) {
  var link = _ref.link;
  return /*#__PURE__*/React.createElement("a", {
    className: "external-link",
    href: link,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "external-link"
  }), renderLinkText(link));
};
var ExternalLinks = function ExternalLinks(_ref2) {
  var links = _ref2.links;
  return /*#__PURE__*/React.createElement(React.Fragment, null, links && links.map(function (link) {
    return /*#__PURE__*/React.createElement(SingleLink, {
      link: link.link,
      key: link.id
    });
  }));
};
export default ExternalLinks;